// extracted by mini-css-extract-plugin
module.exports = {"table__table":"x_fj","table__table_size_lg":"x_fk","table__table_size_xl":"x_fl","table__row":"x_fm","table__row_isNoBg":"x_fn","table":"x_fp","table__columnPriority":"x_fq"};